<template>
    <MenuBaseSubmenu :listenerId="listenerId">
        <span class="menu_submenu__category_label mt-2 flex xl:hidden">{{ $t('lang.menu.ads_label') }}</span>
        <a :href="getLink('/yandex-direct')" class="flex xl:hidden">
            <i class="ksi ksi-yandex-direct"></i>
            <span>{{ $t('lang.menu.yandex_direct') }}</span>
        </a>
        <a :href="getLink('/rsya')" class="flex xl:hidden">
            <i class="ksi ksi-rsya"></i>
            <span>{{ $t('lang.menu.rsya') }}</span>
        </a>
        <Divider class="flex xl:hidden" />
        <a :href="getLink('/monitoring-list')">
            <i class="ksi ksi-monitoring-list"></i>
            <span>{{ $t('lang.menu.monitoring_list') }}</span>
        </a>
        <a :href="getLink('/ai-tracker-list')" class="top_menu__item_new">
            <i class="ksi ksi-ai-tracker-list"></i>
            <span>{{ $t('lang.menu.ai_tracker') }}</span>
        </a>
    </MenuBaseSubmenu>
</template>

<script>
import {Listeners} from "../../../constants/listeners";
import MenuBaseSubmenu from "./BaseSubmenu.vue";
import Divider from "primevue/divider";

export default {
    name: "MenuSubmenuTopMore",
    data() {
        return {
            listenerId: Listeners.TOP_MENU_TOP_MORE_HOVER,
        };
    },
    methods: {
        getLink(url) {
            return sprintf('/%s%s', window.locale, url);
        },
    },
    components: {
        MenuBaseSubmenu,
        Divider,
    },
}
</script>

<style scoped>
.menu_submenu__category_label {
    color: #fff !important;
    padding: 8px 16px;
}
</style>
